<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Upload Invoice</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <!-- Drop zone -->
  <div *ngIf="files.length == 0"
       class="add-files rounded text-center p-4"
       style="border-style: dashed !important; cursor: pointer;"
       (dragover)="dragOver($event)"
       (dragleave)="dragLeave($event)"
       (drop)="dragDrop($event)">
    Add File
  </div>

  <!-- File list -->
  <div *ngFor="let file of files; let i = index"
       class="d-flex align-items-center justify-content-between border-bottom py-2 small">
    <span>{{file.fileName}}</span>
    <button type="button" class="btn btn-link text-danger p-0" (click)="removeFile(i)">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>

  <!-- Fee type -->
  <div *ngIf="files.length > 0" class="mt-3">
    <label class="form-label fw-semibold">Invoice Fee Type</label>
    <select class="form-select" [(ngModel)]="feeType">
      <option [value]="null">Select Type</option>
      <option *ngFor="let feeType of feeTypes" [value]="feeType.id">{{feeType.description}}</option>
    </select>
    <div *ngIf="hasError" class="text-danger small mt-1">{{errorMessage}}</div>
  </div>

</div>

<div class="modal-footer" *ngIf="files.length > 0 && feeType != null">
  <button type="button" class="btn btn-success"
    [disabled]="uploadingInvoice"
    (click)="uploadInvoice()">
    <span *ngIf="uploadingInvoice" class="spinner-border spinner-border-sm me-1" role="status"></span>
    Upload
  </button>
</div>